import { MouseEvent } from 'react';
import { useStyles } from './close-button.style';

type closeButtonProps = {
    /**
     * Click event
     */
    onClickEvent: (val: boolean) => void;
    /**
     * Text for close button
     */
    text?: string;
};
const CloseButton = ({ onClickEvent, text = 'Luk' }: closeButtonProps) => {
    const classes = useStyles();
    function handleOnClickEvent(e: MouseEvent) {
        e.preventDefault();
        onClickEvent(false);
    }

    return (
        <span
            data-testid="closebtn"
            className={classes.wrapper}
            onClick={(e: MouseEvent) => {
                handleOnClickEvent(e);
            }}
        >
            <span className={classes.left}>{text}</span>
            <span className={classes.right}>
                <span className={`${classes.cross} crossOver`}>
                    <flos-icon shape={'plus'} size="20" />
                </span>
                <span className={`${classes.arrow} arrowOver`}>
                    <flos-icon shape="arrow" dir="down" />
                </span>
            </span>
        </span>
    );
};

export { CloseButton };
export type { closeButtonProps };
